"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const react_easy_emoji_1 = __importDefault(require("react-easy-emoji"));
const styled_components_1 = __importDefault(require("styled-components"));
const Explanation_1 = __importDefault(require("../Explanation"));
const writtenNumbers_1 = __importDefault(require("../writtenNumbers"));
const common_1 = require("./common");
function Variations({ nodeValue, explanation, unit }) {
    let [expandedVariation, toggleVariation] = react_1.useState(null);
    return (jsx_runtime_1.jsx(StyledComponent, { children: jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "variations", displayName: false, unit: unit, value: nodeValue }, { children: jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs(common_1.CapitalizeFirstLetter, { children: [writtenNumbers_1.default[explanation.length], ' ', jsx_runtime_1.jsx(common_1.InlineMecanismName, { name: "variations" }, void 0), " possibles :"] }, void 0), jsx_runtime_1.jsx("ol", { children: explanation.map(({ condition, consequence, satisfied }, i) => (jsx_runtime_1.jsxs("li", Object.assign({ style: {
                                transition: 'all 0.2s',
                                opacity: expandedVariation === i || satisfied || nodeValue == null
                                    ? 1
                                    : 0.8,
                            } }, { children: [!satisfied && nodeValue != null && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("em", { children: "non applicable " }, void 0), expandedVariation !== i ? (jsx_runtime_1.jsxs("button", Object.assign({ className: "ui__ link-button", onClick: () => toggleVariation(i) }, { children: ["d\u00E9tails ", react_easy_emoji_1.default('▶️')] }), void 0)) : (jsx_runtime_1.jsxs("button", Object.assign({ className: "ui__ link-button", onClick: () => toggleVariation(null) }, { children: ["replier ", react_easy_emoji_1.default('🔽')] }), void 0))] }, void 0)), (expandedVariation === i ||
                                    satisfied ||
                                    nodeValue == null) && (jsx_runtime_1.jsxs("div", Object.assign({ style: { margin: '1rem 0' } }, { children: [!condition.isDefault && (jsx_runtime_1.jsxs("div", Object.assign({ style: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'baseline',
                                                marginBottom: '0.4rem',
                                            } }, { children: ["Si :\u00A0", jsx_runtime_1.jsx(Explanation_1.default, { node: condition }, void 0)] }), void 0)), jsx_runtime_1.jsxs("div", Object.assign({ style: {
                                                display: 'flex',
                                                width: 'fit-content',
                                                flexWrap: 'wrap',
                                                alignItems: 'baseline',
                                            } }, { children: [jsx_runtime_1.jsxs("span", Object.assign({ className: classnames_1.default('consequenceType', {
                                                        satisfied,
                                                    }) }, { children: [!condition.isDefault ? 'Alors' : 'Sinon', " :\u00A0"] }), void 0), jsx_runtime_1.jsx("span", Object.assign({ className: classnames_1.default('consequenceContent', {
                                                        satisfied,
                                                    }) }, { children: consequence && jsx_runtime_1.jsx(Explanation_1.default, { node: consequence }, void 0) }), void 0)] }), void 0)] }), void 0))] }), i))) }, void 0)] }, void 0) }), void 0) }, void 0));
}
exports.default = Variations;
const StyledComponent = styled_components_1.default.div `
	.mecanism > ol {
		margin-left: 1rem;
		margin-top: 1rem;
	}
	.mecanism > ol > li {
		margin-bottom: 0.3em;
	}
	.mecanism > ol > li span.consequenceType {
		margin: 0 0.6em 0.6em 0;
	}

	.mecanism > ol > li span.consequenceType.satisfied {
		background: yellow;
	}
`;
